import { css, Global } from '@emotion/react';

import {
  getCssVariables,
  getFontFaces,
} from '../../../apps/explore/styles/CSSVariables';

export const WidgetStyles = () => (
  <Global
    styles={() => css`
      :root {
        ${getFontFaces()}

        * {
          box-sizing: border-box;
        }

        sembo-auth,
        #headlessui-portal-root {
          ${getCssVariables()}
        }
      }
    `}
  />
);
